export const DATE_FORMAT = 'D MMM YYYY'
export const DATE_MONTH_FORMAT = 'D MMMM'
export const DATE_FORMAT_WITH_DAY_OF_WEEK = 'D MMM., YYYY, dd'
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DATE_TIME_FORMAT_WITHOUT_SEC = 'YYYY-MM-DD HH:mm'
export const DATE_TIME_FORMAT_BY_MERIDIEM = 'DD MMM YYYY, hh:mm A'
export const DATE_TIME_FORMAT_IN_THIS_YEAR = 'DD MMM [at] hh:mm a'
export const DATE_TIME_FORMAT_BY_MERIDIEM_HUMAN = 'DD MMM YYYY, h:mm A'
export const DATE_MONTH_YEAR_FORMAT = 'MMMM YYYY'
